import React from 'react';
import { Link } from 'react-router-dom';

const TermsPage = () => {
  return (
    <div 
      className="min-h-screen px-6 py-12"
      style={{ background: '#F5EFE6' }}
      data-testid="terms-page"
    >
      <div className="w-full max-w-3xl mx-auto">
        <Link 
          to="/" 
          className="inline-flex items-center text-sm mb-8 hover:opacity-70 transition-opacity"
          style={{ color: '#1A4D2E' }}
          data-testid="back-link"
        >
          &larr; Terug naar home
        </Link>

        <h1 
          className="text-2xl sm:text-3xl font-bold mb-2"
          style={{ color: '#1A4D2E' }}
        >
          Algemene Voorwaarden
        </h1>
        <p className="text-sm mb-8" style={{ color: '#1A4D2E', opacity: 0.6 }}>
          Laatst bijgewerkt: 13 april 2026
        </p>

        <div className="space-y-6 text-sm leading-relaxed" style={{ color: '#1A4D2E' }}>
          <section>
            <h2 className="text-lg font-semibold mb-2">1. Identiteit van de dienstverlener</h2>
            <p>
              TalentFixr is een online platform gevestigd in België dat techniekers verbindt 
              met werkgevers via een matching-systeem. Door gebruik te maken van dit platform 
              aanvaardt u deze algemene voorwaarden.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2">2. Definities</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Platform</strong>: de website en applicatie van TalentFixr</li>
              <li><strong>Gebruiker</strong>: elke persoon die zich registreert op het platform</li>
              <li><strong>Kandidaat</strong>: een gebruiker die zich inschrijft als werkzoekende technieker</li>
              <li><strong>Diensten</strong>: het matching-systeem en gerelateerde functionaliteiten aangeboden door TalentFixr</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2">3. Toegang tot het platform</h2>
            <p>
              TalentFixr is momenteel in testfase en toegang is gratis voor kandidaten. 
              Wij behouden ons het recht voor om in de toekomst toegangsvoorwaarden te wijzigen, 
              met voorafgaande kennisgeving aan geregistreerde gebruikers.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2">4. Registratie en account</h2>
            <p>Bij registratie verbindt de gebruiker zich ertoe:</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Correcte en waarheidsgetrouwe informatie te verstrekken</li>
              <li>Zijn/haar gegevens up-to-date te houden</li>
              <li>Geen valse identiteit aan te nemen</li>
              <li>Maximaal één account per persoon aan te maken</li>
            </ul>
            <p className="mt-2">
              TalentFixr behoudt zich het recht voor om accounts te verwijderen die 
              onjuiste informatie bevatten of in strijd zijn met deze voorwaarden.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2">5. Verplichtingen van de gebruiker</h2>
            <p>De gebruiker verbindt zich ertoe:</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Het platform niet te gebruiken voor onwettige doeleinden</li>
              <li>Geen spam of ongewenste berichten te versturen via het platform</li>
              <li>De intellectuele eigendomsrechten van TalentFixr en derden te respecteren</li>
              <li>Geen technische kwetsbaarheden van het platform te exploiteren</li>
              <li>Geen geautomatiseerde systemen te gebruiken om data van het platform te verzamelen</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2">6. Intellectuele eigendom</h2>
            <p>
              Alle inhoud op het platform, inclusief maar niet beperkt tot teksten, 
              grafische elementen, logo's, iconen en software, is eigendom van TalentFixr 
              of haar licentiegevers en wordt beschermd door het Belgisch en internationaal 
              auteursrecht en intellectueel eigendomsrecht.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2">7. Matching en vacatures</h2>
            <p>
              TalentFixr biedt een matching-dienst aan op basis van de door de gebruiker 
              verstrekte informatie. Wij garanderen niet:
            </p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Dat er een match gevonden wordt</li>
              <li>De kwaliteit of geschiktheid van voorgestelde vacatures</li>
              <li>Dat een match leidt tot een effectieve aanwerving</li>
            </ul>
            <p className="mt-2">
              TalentFixr is een bemiddelingsplatform en is geen partij bij eventuele 
              arbeidsovereenkomsten tussen kandidaten en werkgevers.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2">8. Aansprakelijkheid</h2>
            <p>
              TalentFixr stelt alles in het werk om een betrouwbare dienst aan te bieden, 
              maar kan niet aansprakelijk gesteld worden voor:
            </p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Tijdelijke onbeschikbaarheid van het platform</li>
              <li>Verlies van gegevens door technische storingen</li>
              <li>Handelingen van derden (werkgevers, andere gebruikers)</li>
              <li>Indirecte schade voortvloeiend uit het gebruik van het platform</li>
            </ul>
            <p className="mt-2">
              De aansprakelijkheid van TalentFixr is in elk geval beperkt conform het 
              Belgisch recht (Boek VI van het Wetboek van Economisch Recht).
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2">9. Privacy en gegevensbescherming</h2>
            <p>
              De verwerking van persoonsgegevens wordt geregeld door ons{' '}
              <Link to="/privacy" className="underline font-medium" style={{ color: '#1A4D2E' }}>
                Privacybeleid
              </Link>
              , dat integraal deel uitmaakt van deze algemene voorwaarden. Wij verwerken 
              uw gegevens in overeenstemming met de Algemene Verordening Gegevensbescherming 
              (AVG/GDPR) en de Belgische Wet van 30 juli 2018 betreffende de bescherming 
              van natuurlijke personen met betrekking tot de verwerking van persoonsgegevens.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2">10. Beeindiging</h2>
            <p>
              De gebruiker kan op elk moment zijn account laten verwijderen door contact 
              op te nemen met TalentFixr. TalentFixr kan een account beeindigen bij 
              schending van deze voorwaarden, na voorafgaande waarschuwing tenzij de 
              schending ernstig is.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2">11. Herroepingsrecht</h2>
            <p>
              Aangezien de dienst momenteel gratis wordt aangeboden, is het herroepingsrecht 
              zoals voorzien in Boek VI van het Wetboek van Economisch Recht (omzetting van 
              de Europese Richtlijn 2011/83/EU) niet van toepassing. Mocht de dienst in de 
              toekomst betalend worden, zal het herroepingsrecht van 14 dagen gerespecteerd worden.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2">12. Wijzigingen aan de voorwaarden</h2>
            <p>
              TalentFixr behoudt zich het recht voor om deze algemene voorwaarden te wijzigen. 
              Gebruikers worden minstens 30 dagen op voorhand op de hoogte gebracht van 
              wezenlijke wijzigingen. Voortgezet gebruik van het platform na kennisgeving 
              geldt als aanvaarding van de gewijzigde voorwaarden.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2">13. Toepasselijk recht en geschillen</h2>
            <p>
              Deze algemene voorwaarden worden beheerst door het Belgisch recht. In geval 
              van geschillen wordt eerst getracht tot een minnelijke schikking te komen. 
              Indien dit niet lukt, zijn de rechtbanken van het gerechtelijk arrondissement 
              waar TalentFixr gevestigd is bevoegd.
            </p>
            <p className="mt-2">
              Voor consumenten geldt dat zij ook een klacht kunnen indienen bij het 
              Europees platform voor onlinegeschillenbeslechting (ODR):{' '}
              <a 
                href="https://ec.europa.eu/consumers/odr" 
                target="_blank" 
                rel="noopener noreferrer"
                className="underline"
                style={{ color: '#1A4D2E' }}
              >
                https://ec.europa.eu/consumers/odr
              </a>
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2">14. Contactgegevens</h2>
            <p>
              Voor vragen over deze algemene voorwaarden kunt u contact opnemen via 
              het e-mailadres vermeld op onze website.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-6 border-t" style={{ borderColor: 'rgba(26, 77, 46, 0.15)' }}>
          <p className="text-xs" style={{ color: '#1A4D2E', opacity: 0.5 }}>
            &copy; 2026 TalentFixr. Alle rechten voorbehouden.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
